import React, { useEffect } from 'react'
import { Outlet, Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../_metronic/helpers/AssetHelpers'

interface Props {
    children: any
}

const AuthLayout = ({ children }: Props) => {
    useEffect(() => {
        const root = document.getElementById('root')
        if (root) {
            root.style.height = '100%'
        }
        return () => {
            if (root) {
                root.style.height = 'auto'
            }
        }
    }, [])

    return (
        <div style={{ backgroundSize: 'cover', backgroundImage: `url(${toAbsoluteUrl('media/misc/bg-3.jpg')})` }} className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
            {/* begin::Body */}
            <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
                {/* begin::Form */}
                <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
                    {/* begin::Wrapper */}
                    <div className='w-lg-500px p-10'>
                        {children}
                    </div>
                    {/* end::Wrapper */}
                </div>
                {/* end::Form */}

                {/* begin::Footer */}

                {/* end::Footer */}
            </div>
            {/* end::Body */}

            {/* begin::Aside */}
        </div>
    )
}

export { AuthLayout }